function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  version: "1.0",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 283.5 283.5"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M269.3 78l-14.2 29.7v175.8h28.4V107.7L269.3 78zM14.2 0v283.5h212.6V92.1L120.5 0H14.2zm120.4 49.8L167.1 78h-32.5V49.8zM42.5 255.1V28.3h63.8v78h92.1v148.8H42.5z"
})));